export default __webpack_public_path__ + "static/1-14165c85e86818d14d9be9e8ad896585.jpeg";